module.exports = __webpack_public_path__ + "img/nav_pfeil.a6b0c11e.svg";